import { render } from "./scene.vue?vue&type=template&id=7cef093f&scoped=true"
import script from "./scene.vue?vue&type=script&lang=js"
export * from "./scene.vue?vue&type=script&lang=js"

import "./scene.vue?vue&type=style&index=0&id=7cef093f&lang=less&scoped=true"
import "./scene.vue?vue&type=style&index=1&id=7cef093f&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cef093f"]])

export default __exports__